var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"block mr-8 last:mr-0"},[_c('router-link',_vm._b({staticClass:"block py-4 text-gray-500 text-sm border-b-2 -mb-px-2",class:{
      'border-secondary text-gray-800': _vm.active
    }},'router-link',_vm.$attrs,false),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }